module.exports = __webpack_public_path__ + "img/logo.d8eae7c0.png";